<template>
  <div>
    <div class="grid grid-cols-12 gap-x-5">
      <BaseInputForm
        class="col-span-full"
        label="Тип фильтрации:"
      >
        <SelectButton
          v-model="receiversScope"
          class="w-full text-sm"
          option-label="title"
          option-value="code"
          :disabled="formDisabled"
          :options="[
            {
              code: 'all',
              title: 'Всем'
            },
            {
              code: 'selected',
              title: 'Выбранным'
            }
          ]"
          :pt="{
            button: 'text-sm'
          }"
        />
      </BaseInputForm>

      <BaseInputForm
        v-if="distributionMethodVisible"
        class="col-span-full"
        label="Фильтровать по:"
      >
        <SelectButton
          v-model="distributionMethod"
          class="w-full text-sm"
          option-label="title"
          option-value="code"
          :disabled="formDisabled"
          :options="[
            {
              code: 'salespoint',
              title: 'Торговым точкам'
            },
            {
              code: 'group',
              title: 'Группам торговых точек'
            }
          ]"
          :pt="{
            button: 'text-sm'
          }"
        />
      </BaseInputForm>

      <BaseInputForm
        v-if="distributionMethod === 'salespoint'"
        class="col-span-full"
        label="Список торговых точек"
      >
        <PickListSalespoint v-model:selected="salespoint_ids" />
      </BaseInputForm>

      <BaseInputForm
        v-if="distributionMethod === 'group'"
        class="col-span-full"
        label="Список групп торговых точек"
      >
        <PickListSalespointgroup v-model:selected="group_ids" />
      </BaseInputForm>

      <BaseInputForm
        class="col-span-full"
        label="Сообщение"
      >
        <Textarea
          v-model="message"
          class="w-full min-h-[49px]"
          autoResize
          :disabled="formDisabled"
        />
      </BaseInputForm>

      <BaseInputForm
        class="col-span-full"
        label="Файл"
      >
        <InputScan
          v-model="file"
          :disabled="formDisabled"
        />
      </BaseInputForm>
    </div>

    <BaseDiver />

    <div class="flex justify-between">
      <div v-tooltip="sendGlobalMessageDisabledReason">
        <Button
          label="Отправить глобальное сообщение"
          :disabled="sendGlobalMessageDisabled"
          :loading="sendGlobalMessagePending"
          @click="sendGlobalMessage"
        />
      </div>

      <Button
        label="Вернуться к чату поддержки"
        severity="secondary"
        class="bg-gray-200 text-gray-800 border border-solid border-gray-300"
        @click="goToThreads"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useModel } from '../../model'
import { computed } from 'vue'
import SelectButton from 'primevue/selectbutton'
import { BaseDiver, BaseInputForm, InputScan } from '@/shared'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import { useRouter } from 'vue-router'
import { routesNames } from '@/app/router'
import { PickListSalespoint, PickListSalespointgroup } from '@/features/salespoint'

const router = useRouter()
const model = useModel()
const {
  file,
  message,
  formDisabled,
  receiversScope,
  distributionMethod,
  salespoint_ids,
  group_ids,
  sendGlobalMessage,
  sendGlobalMessagePending,
  sendGlobalMessageDisabled,
  sendGlobalMessageDisabledReason
} = model

const distributionMethodVisible = computed(
  () => receiversScope.value === 'except_selected' || receiversScope.value === 'selected'
)

function goToThreads() {
  router.push({ name: routesNames.chatmessage.threads })
}
</script>
